var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHelpfulIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.15 62.024",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".helpful_icon_svg__a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "helpful_icon_svg__a",
    d: "M57.6 11.18H35.359V8.219l-.5-1.815-.538-1.613-.706-1.479-1.247-1.478-1.378-.706h-3.024l-1.345.271.3 2.386.739 3.7-.437 2.083-.944 1.617H3.554A2.548 2.548 0 001 13.734V45.38a2.548 2.548 0 002.554 2.554h9.432v13.09L26 48.005v-.074h31.6a2.554 2.554 0 002.55-2.551V13.734a2.554 2.554 0 00-2.55-2.554z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.995 1.023)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "helpful_icon_svg__a",
    d: "M36.349 21.285h1.107a3.211 3.211 0 010 6.422h-1.107m-.005 0a3.208 3.208 0 010 6.416h-2.165m0 0h-.044a3.211 3.211 0 010 6.422H8.6m0-19.609c0-3.947 9.411-8.813 8.714-15.191L16.6.209s3.549-.5 4.766.05c3.128 1.4 3.925 5.951 3.925 9.289a19.542 19.542 0 01-.8 5.314h11.857a3.212 3.212 0 010 6.423M0 20.615h8.6v19.929H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "helpful_icon_svg__a",
    cx: 0.808,
    cy: 0.808,
    r: 0.808,
    transform: "translate(3.438 36.06)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHelpfulIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/helpful_icon.a5ce2ddce952c8a6f682854a31ff1d59.svg";